/** «Chrome en Windows», «Safari en iPhone»… para nombrar una passkey (A11, auditoría 2026-10-02).
 *  Antes se usaba navigator.platform: «Win32», «MacIntel», que nadie reconoce en la lista. */
export function nombreDispositivo(ua = (typeof navigator !== 'undefined' ? navigator.userAgent : '') || '', siNoSe = 'Este dispositivo') {
  const so = /iPhone/.test(ua) ? 'iPhone'
    : /iPad/.test(ua) ? 'iPad'
      : /Android/.test(ua) ? 'Android'
        : /Windows/.test(ua) ? 'Windows'
          : /Mac OS X|Macintosh/.test(ua) ? 'Mac'
            : /Linux/.test(ua) ? 'Linux' : null;
  const nav = /Edg\//.test(ua) ? 'Edge'
    : /OPR\/|Opera/.test(ua) ? 'Opera'
      : /Firefox\//.test(ua) ? 'Firefox'
        : /Chrome\/|CriOS\//.test(ua) ? 'Chrome'
          : /Safari\//.test(ua) ? 'Safari' : null;
  if (nav && so) return `${nav} en ${so}`;
  return nav || so || siNoSe;
}
